import React from 'react'
import { isNil } from 'lodash'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { compose, withState, withHandlers, lifecycle, withProps } from 'recompose'
import { injectIntl } from 'react-intl'

import { fetchingState } from '../helpers/hocs.js'
import { get, send } from '../store/reducers/feedback'

import Form from './Form'
import Loader from './Loader'


const ContactsForm = ({ success = null, topics, data = {}, tmpData, setData, peoceed, fetching, submit, intl, errors, error }) => {return (
  <div className='Contacts-form__body'>
    {
      success ? <div className='Contacts-form__title Head'>
        Your message was sent!
      </div>
        : (
          <div>
            <h1 className='Contacts-form__title Head'>
              Contact us
            </h1>
            {!fetching.info && (
              <div>
                {<Form value={tmpData.name} noAutoFocus={true} disableBtn={true} onInput={setData('name')} placeholder={"Enter your name"}/>}
                {
                  <div>
                  <Form value={tmpData.contact} noAutoFocus={true} disableBtn={true} onInput={setData('contact')} placeholder={"Enter a valid email address"} />
                  {errors && errors.contact && <div className='PaymentMethod__title'>Missing/incorrect email</div>}
                </div>
                
                }
                {<Form value={tmpData.message} noAutoFocus={true} onInput={setData('message')} placeholder={"Enter your message"} onSubmit={submit} enSubmitTitle={"Submit"} />}
              </div>
            )}

            {(fetching.send || fetching.info) && <Loader isLight />}
            {!isNil(success) && <div className='Text'>
              Ошибка отправки сообщения
            </div>}
          </div>
        )
    }
  </div>
)}

const mapStateToProps = state => ({ ...state.feedback })

const mapDispatchToProps = dispatch => bindActionCreators({ get, send }, dispatch)

export default injectIntl(compose(
  connect(mapStateToProps, mapDispatchToProps),
  withState('data', 'setData', {}),
  withState('tmpData', 'setTmpData', {}),
  withState('success', 'setSuccess', null),
  withState('errors', 'setErrors', {}),
  withState('error', 'setError', ''),
  fetchingState({ multi: true }),
  withHandlers({
    get: ({ get, fetchingWrap }) => () => fetchingWrap(get.bind(this), 'info'),
    setData: ({ setTmpData, tmpData, errors, setErrors }) => field => e => {
      tmpData[field] = e
      if(field === "contact") {
        if (!tmpData[field]) {
          errors.contact = true
        } else if (tmpData[field]) {
          var re = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;;
          var valid = re.test(tmpData[field]);
          if (valid) {
            delete errors.contact;
          } else {
            errors.contact = true
          }
        }
        setErrors(errors)
      }
      setTmpData(tmpData)
    },
    clearData: ({ setData }) => () => {
      setData({})
    },
    submit: ({ send, info, tmpData, data, setSuccess, fetchingWrap, setError, setErrors, errors }) => async e => {
      e && e.preventDefault()
      setSuccess(null)
      data = { ...info, ...tmpData, topic: "engLanding-contacts"}
      //let errors = {};
      setErrors(errors)
      if (Object.keys(errors).length === 0) {
        const result = await fetchingWrap(send.bind(this, data), 'send')
        if (result === 200) {
          setSuccess(true)
          setError('')
        } else {
          setSuccess(true)
          setError('Error')
        }
      }
    }
  }),
  withProps(props => ({
    data: { ...props.info, ...props.data },
    tmpData: { ...props.info, ...props.tmpData }
  })),
  lifecycle({
    componentWillMount () {
      this.props.clearData()
      this.props.setTmpData({})
      this.props.get()
    },
    componentWillUnmount () {
      this.props.setTmpData({})
      this.props.setSuccess(null)
      this.props.clearData()
    }
  })
)(ContactsForm))



// WEBPACK FOOTER //
// ./src/components/ContacsEngForm.jsx